import React from "react";
import classNames from "classnames";

const ActivityIsland = ({ icon, compartments }) => {
    return <div className="activityIslandContainer" style={{ flexShrink: "1", flexGrow: "0", width: "max-content" }}>
        <span>{icon}</span>
        {
            compartments
                .filter(Boolean) // Delete null value
                .map((el, index, array) =>
                    <React.Fragment key={index}>
                        <span className="TextContent16" style={{ display: "flex", gap: "5px" }}>{el}</span>
                        {index < array.length - 1 ? <span className="VerticalSeparator" style={{ margin: 0 }}/> : null}
                    </ React.Fragment>
                )
        }
    </div>;
};

export default ActivityIsland;
